;
( function( $, window, document, undefined )
{
    'use strict';

    var Thread = function( element, options )
    {
        $.fn.reverse = [].reverse;
        this.options = options;
        this.els     = options.els;
        this.$editorClone = $( '.reply-editor' ).eq( 0 ).clone();
        this.registered = LITHIUM.CommunityJsonObject.User.registered;
        this.$body = $( 'body' );
        this.t = $( 'html, body' );
        this.init();
    };

    Thread.prototype = {

        init : function()
        {
            // temporary changing the number of emoticons since the page is taking ages to load
            try {
                //LITHIUM.TinyMceEditor.emoticonsHtml.html_original = LITHIUM.TinyMceEditor.emoticonsHtml.html;
                window.emoticons_html = LITHIUM.TinyMceEditor.emoticonsHtml.html;
                LITHIUM.TinyMceEditor.emoticonsHtml.html = '';
            } catch( e ){}

            var that = this;

            this.layout();

            var $scrollTo = $( '#scroll-to' );

            if ($('#PDC6-main-container').hasClass('isAR')) {
                var $scope = window.LITHIUM.angular.element($('.lia-content.ng-scope')).scope();
                $scope._close = $scope.close
                $scope.close = function ($event, ignoreEvent) {
                    $scope._close($event, ignoreEvent);
                    setTimeout(function(){
                        $('center').offset({top: 0, left: 0})
                    }, 20);
                };
              }

            $('.mobile-extra--share').click(function (e) {
                e.preventDefault();

                $(this).toggleClass('active').nextAll('.share').toggleClass('active');
            });

            $('.mobile-extra--reply').click(function (e) {
                e.preventDefault();

                that.t.scrollTo( $('#after-first-message').offset().top - 60, 0 );
            });

            $('.mobile-extra--options .handler').click(function (e) {
                e.preventDefault();

                var $t = $(this)
                    .parent()
                    .toggleClass('active')
                    .closest('.thread-opening')
                    .toggleClass('with-dropdown');

                // if ($t.hasClass('with-dropdown')) {
                //     $('body').scrollTop($(this).next().offset().top - 64);
                // }

                var action = $t.hasClass('with-dropdown') ? 'open' : 'close';

                $.fn.SiteCatalyst('track', 'Thread - More options', {
                    type   : 'o',
                    vars   : {
                        prop49 : 'button:more-options-' + action + ':side-menu:%pageName%',
                        eVar49 : 'D=c49'
                    },
                    events : [ 66 ]
                });
            });

            $('.dropdown-backdrop').on('click', function () {
                $(this).prev().toggleClass('active').closest('.thread-opening').toggleClass('with-dropdown');
            });

            var share = $('.share-button .label').eq(0).text();

            $('.mobile-extra__list').each(function () {
                var $message  = $(this).closest('.thread-message');
                var $solution = $message.find('[class*="lia-component-solutions-action"]').clone();
                var $report   = $message.find('.report-abuse-link').eq(0).clone();
                var $edit     = $message.find('.lia-link-navigation.edit-message').clone();
                var $history  = $message.find('.lia-link-navigation.view-message-history').clone();
                var $move     = $message.find('.lia-link-navigation.move-message').eq(0).clone();
                var $likes    = $message.find('.lia-link-navigation.make-unkudosable-link').eq(0).clone();
                var $spam     = $message.find('.lia-link-navigation.lia-component-spam-action-mark-message-as-spam').clone();

                if ($solution.size()) {
                    $(this).find('.extra--solution').replaceWith($solution);
                } else {
                    $(this).find('.extra--solution').parent().remove();
                }

                if ($(this).closest('.first-message').size()) {
                    $(this).find('.extra--share').hide();
                } else {
                    $(this).find('.extra--share').text(share);
                }

                $(this).find('.extra--report').replaceWith($report);

                if ($edit.size()) {
                    $(this).append($('<li />').append($edit));
                }

                if ($history.size()) {
                    $(this).append($('<li />').append($history));
                }

                if ($move.size()) {
                    $(this).append($('<li />').append($move));
                }

                if ($likes.size()) {
                    $(this).append($('<li />').append($likes));
                }

                if ($spam.size()) {
                    $(this).append($('<li />').append($spam));
                }
            });

            $('.extra--share').on('click', function (e)
            {
                e && e.preventDefault();
                var $options = $(this).closest('.mobile-extra').closest('.thread-message').find('.reply-right-actions');
                $options.find('.lia-link-navigation.lia-js-add-this-widget').click();
                $(this).closest('.mobile-extra').next().click();
            });

            //$('.lia-discussion-view-style-menus').remove();

            if( $scrollTo.size() )
            {
                this.scrollToMessage( $( '.thread-opening[data-id="' + $scrollTo.data( 'anchor' ).replace( 'M', '' ) + '"]' ) );
            }

            if( !this.registered )
            {
                $( '.inside-wrapper-reply-inline' ).on( 'click', function( e )
                {
                    e.preventDefault();
                    e.stopPropagation();

                    that.showModal();
                    common.els.$body.header('toggleBodyOverflow', true);
                } );

                $('.mobile-extra.mobile-extra--reply').on( 'click', function( e )
                {
                    e.preventDefault();
                    e.stopPropagation();

                    that.showModal();
                    common.els.$body.header('toggleBodyOverflow', true);
                    return false;
                } );

                $('.lia-link-navigation.kudos-link.lia-link-ticket-post-action').attr('href', '#');

                $( '.lia-link-navigation.kudos-link.lia-link-ticket-post-action' ).on( 'click', function( e )
                {
                    e.preventDefault();
                    e.stopPropagation();

                    that.showModal();
                    common.els.$body.header('toggleBodyOverflow', true);
                    return false;
                } );
            }

            $( '.edit-message' ).on( 'click', $.proxy( this.editReply, this ) );

            $( '#thread-login-prompt-modal' ).on( 'click', '.pdc6-modal-close', function( e )
            {
                e && e.preventDefault();

                that.$body.removeClass( 'with-modal' );
                common.els.$body.header('toggleBodyOverflow', false);
            } );

            this.reply();
            $( '#reply-editor-main-top' ).EditorPDC();
            $( '#reply-editor-main-bottom' ).EditorPDC();
            this.progressBar();
            this.emojis();

            $( '.pdc6-button--submit-reply' ).click( this.submitReply );
        },

        emojis : function()
        {
            twemoji.parse($('.MinimumWidthContainer')[0]);
            // $('.lia-message-body-content').each(function() {
            //     $(this).contents()
            //     .filter(function() {
            //         return this.nodeType === 3;
            //     }).each(function () {
            //         twemoji.parse( this )
            //     });
            // });
        },

        showModal : function()
        {
            this.$body.addClass( 'with-modal' );
        },

        replaceElementWith : function( $el, tag )
        {
            $el.replaceWith( '<' + tag + ' href="#" class="' + $el.attr( 'class' ) + '">' + $el[ 0 ].innerHTML + '</' + tag + '>' );
        },

        editReply : function( e )
        {
            // if is the main message, let's redirect to the edit page
            if( $( e.target ).closest( '.first-message' ).size() )
            {
                return;
            }

            // prevent default event
            e && e.preventDefault();

            // referencing the main object
            var that = this;

            // getting some divs
            var $thread  = $( e.target ).closest( '.thread-opening' );
            var $message = $thread.find( '.thread-message' );
            var $loading = $thread.find( '.thread-message-loading' );
            var $editing = $thread.find( '.thread-message-editing' );
            var id       = $thread.data( 'unique-id' );
            var endpoint = '/playstationeu/restapi/vc/messages/id/';

            // adding loading class to main container to show loader
            $thread.addClass( 'loading' );
            $loading.css( { 'min-height' : $message.css( 'height' ) } );

            // retrieve original message using the API
            $.ajax( {
                type : 'GET',
                url  : endpoint + id,
                data : {
                    'restapi.response_style'  : 'view',
                    'restapi.response_format' : 'json'
                },
                success : function ( result ) {
                    // create the new editor
                    var $editor   = that.$editorClone.clone();
                    var $area     = $editor.find( 'textarea' );
                    var editorID  = 'tinyMceEditorId' + new Date().getTime();

                    $area.val( result.response.message.body.$ );
                    $area.attr( 'id', editorID );

                    // show the editing form
                    $editor.appendTo( $editing );
                    $thread.removeClass( 'loading' ).addClass( 'editing' );
                    $( '#' + editorID ).EditorPDC();

                    // listen for the "cancel" button
                    $editor.find( '.pdc6-button--cancel-reply' ).on( 'click', function ( e ) {
                        e.preventDefault();

                        // remove loading class
                        $thread.removeClass( 'editing' );

                        // remove editor
                        $editing.html( '' );
                    } );

                    // listen for the "save" button
                    $editor.find( '.pdc6-button--update-reply' ).on( 'click', function ( e ) {
                        e.preventDefault();
                        if ($editor.find('.editing-html').size()) {
                            var body = $editor.find('textarea').val();
                        } else {
                            var body = tinymce.editors[ editorID ].save();
                        }

                        $thread.addClass( 'loading' ).removeClass( 'editing' );

                        // submit the changes
                        $.ajax( {
                            type : 'POST',
                            url  : endpoint + id + '/edit',
                            data : {
                                'message.body'            : body,
                                'restapi.response_style'  : 'view',
                                'restapi.response_format' : 'json'
                            },
                            success : function () {
                                // parse the new message for emojis
                                body = twemoji.parse( body );

                                // switch original message with new one
                                $thread.find( '.lia-message-body-content' ).html( body );

                                // remove loading class
                                $thread.removeClass( 'loading' );

                                // remove editor
                                $editing.html( '' );
                            }
                        } );
                    }.bind( that ) );
                }
            } );
        },

        reply : function()
        {
            var that = this;

            $( '.reply-action-link' ).on( 'click', function( e )
            {
                e && e.preventDefault();

                if( !LITHIUM.CommunityJsonObject.User.registered )
                {
                    $( 'body' ).addClass( 'with-modal' );
                    return;
                }

                $( '#current-reply-editor' ).remove();

                var $editor   = that.$editorClone.clone();
                var id        = 'tinyMceEditorId' + new Date().getTime();
                var $thread   = $( this ).closest( '.thread-opening' );
                var replyToId = $thread.data( 'unique-id' );

                var $avatar = $thread.find( '.author-avatar img' ).eq( 0 );
                var author  = $thread.find( '.user-details' ).data( 'name' );

                window.replyingTo = {
                    'message' : replyToId,
                    'id' : $thread.find( '.user-details' ).data( 'id' ),
                    'name' : author,
                    'href' : $thread.find( '.user-details' ).data( 'href' ),
                    'avatar' : $avatar.attr( 'src' )
                };

                $.ajax({
                    type : 'POST',
                    url  : '/restapi/vc/messages/id/' + replyToId + '/',
                    data : {
                        'restapi.response_style'  : 'view',
                        'restapi.response_format' : 'json'
                    },
                    success : function (result) {
                        window.replyingTo.view_href = result.response.message.view_href;
                    }
                });

                $editor.find( '.author-original' ).find( '.avatar' ).append( $avatar.clone() );
                $editor.find( '.author-original' ).find( '.username' ).html( author );

                $editor.attr( 'id', 'current-reply-editor' );
                $editor.addClass( 'inline-editor' ).find( 'textarea' ).attr( 'id', id );

                var $view = $( this ).closest( '.lia-threaded-detail-display-message-view' );
                var level = $view.children().attr( 'class' );

                if( level != 'lia-thread-level-01' )
                {
                    replyToId = $thread.data( 'parent' );

                    var $next = $( this ).closest( '.lia-threaded-detail-display-message-view' ).nextAll( '.lia-threaded-detail-display-message-view' );

                    if( !$next.size() )
                    {
                        $( this ).closest( '.lia-threaded-detail-display-message-view' ).after( $editor );
                    }
                    else if( $next.eq( 0 ).children().attr( 'class' ) == 'lia-thread-level-01' )
                    {
                        $next.eq( 0 ).before( $editor );
                    }
                    else
                    {
                        var done = false;

                        $next.each( function()
                        {
                            if( $( this ).children().attr( 'class' ) == 'lia-thread-level-01' )
                            {
                                done = true;
                                $( this ).before( $editor );
                                return false;
                            }

                        } );

                        if( !done )
                        {
                            $( this ).closest( '.lia-threaded-detail-display-message-view' ).after( $editor );
                        }
                    }

                    var offset = $editor.offset().top;

                    if( !that.t )
                    {
                        that.t = $( 'html, body' );
                    }

                    var d = 64;

                    that.t.scrollTo( offset - d - parseInt($editor.css('height')), 300 );
                }
                else
                {
                    $view.after( $editor );
                }

                var $button = $editor.find( '.pdc6-button--submit-reply' ).click( that.submitReply );

                $button.data( 'to', replyToId );
                $button.data( 'related-editor-id', id );

                $( '#' + id ).EditorPDC();

                tinyMCE.get(id).focus();
            } );
        },

        submitReply : function( e )
        {
            e && e.preventDefault();

            var prop20 = $.fn.SiteCatalyst.globals.thread.prop20;

            if( !LITHIUM.CommunityJsonObject.User.registered )
            {
                $( 'body' ).addClass( 'with-modal' );
                return;
            }

            if( $( this ).hasClass( 'pdc6-button--disabled' ) )
            {
                return false;
            }

            $( 'body' ).addClass( 'loading locked no-scroll' ).prepend( $( '#common-loader' ).clone().addClass( 'visible' ).attr( 'id', 'main-global-loader' ) );

            var editor   = tinymce.editors[ $( this ).data( 'related-editor-id' ) ];
            var $editor  = $(this).closest('.reply-editor');

            if ($editor.find('.editing-html').size()) {
                var content = $editor.find('textarea').val();
            } else {
                var content = editor.save();
            }

            var replyto  = $( this ).data( 'to' );
            var endpoint = '/playstationeu/restapi/vc/messages/id/' + replyto + '/reply';
            var subscriptionType = $( this ).data( 'related-editor-id' ) == 'reply-editor-main-top' || $( this ).data( 'related-editor-id' ) == 'reply-editor-main-bottom' ? 'thread' : 'message';

            // adding the hidden mention
            if (window.replyingTo && window.replyingTo.id != LITHIUM.CommunityJsonObject.User.id) {
                content = content + '<span class="hidden"><li-user login="' + window.replyingTo.name + '" uid="' + window.replyingTo.id + '">﻿</li-user></span>';
            }

            var data = {
                'message.subject'         : $( '.lia-panel-message-root' ).find( '.lia-message-subject h1' ).text(),
                'message.body'            : content,
                'message.subscribe_type'  : $( this ).closest( '.reply-editor' ).find( '.email-me' ).find( 'input' ).is( ':checked' ) ? subscriptionType : '',
                'restapi.response_style'  : 'view',
                'restapi.response_format' : 'json'
            };

            $.ajax( {
                type : 'POST',
                url  : endpoint,
                data : data,
                success : function( results )
                {
                    if( results.response.status == 'success' )
                    {

                        var url = results.response.message.view_href,
                            key = 'new_reply',
                            id  = results.response.message.id.$,
                            end = '/playstationeu/restapi/vc/messages/id/' + id + '/metadata/key',
                            events = [66],
                            products = null;

                        if ($('.thread-details .replies strong').text()=='0') {
                            var from    = moment($('.lia-panel-message-root .thread-opening').data('time'));
                            var to      = moment();
                            var diff    = moment.duration(to.diff(from));
                            var seconds = diff.asHours() * 3600;

                            events.push('65=' + Math.round(seconds));
                        }

                        $.fn.SiteCatalyst( 'track', 'Reply to thread', {
                            type   : $.fn.SiteCatalyst.eventType.other,
                            vars   : {
                                prop49 : 'button:reply to thread:null:%pageName%',
                                eVar49 : 'D=c49',
                                eVar20 : 'D=c20',
                                prop20 : prop20
                            },
                            events : events,
                            products : products
                        } );

                        $.ajax( {
                            type : 'POST',
                            url  : end + '/scee.replied_to_user_id/set',
                            data : {
                                value : JSON.stringify( window.replyingTo )
                            },
                            success : function()
                            {
                                $.cookie( key, url[ 1 ], { 'expires' : 352, 'path' : '/', 'domain' : window.location.hostname } );
                                window.location.replace( url );
                            }
                        } );
                    }
                    else
                    {
                        alert( results.response.error.message );
                    }
                }
            } );
        },

        layout : function()
        {
            var that = this;
            var $pagination = $( '.lia-paging-full-wrapper:not(#threadnavigator)' );
            var mainID      = $( '.first-message .thread-opening' ).data( 'unique-id' );

            $('.lia-section-header.section-header.section-answer').remove();

            // $('.lia-message-body-content p:last-child').filter(function(){
            //     return $.trim($(this).text()).length == 0
            // }).remove();

            /*
            var $solution   = $( '#threadeddetaildisplaymessageviewwrapper_0 .lia-thread-level-00' );

            if( $solution.size() )
            {
                $solution.addClass( 'force-visibility' );
                var $wrap = $( '#threadeddetaildisplaymessageviewwrapper' );
                $wrap.after( $( '#after-first-message' ).addClass( 'with-solution' ).detach() );
                $wrap.after( $( '#threadeddetaildisplaymessageviewwrapper_0' ).addClass( 'thread-solution' ).detach() );
            }
            */

            $( '.first-message .reply-editor' ).find( '.pdc6-button--submit-reply' ).data( 'to', mainID );
            $( '#thread-bottom-section .reply-editor' ).find( '.pdc6-button--submit-reply' ).data( 'to', mainID );

            if( $( '#logged-in-user' ) )
            {
                var $avatar = $( '#logged-in-user' ).find( 'img' ).clone();
                $avatar.attr( 'width', '' );
                $avatar.attr( 'height', '' );

                $( '.reply-editor' ).each( function()
                {
                    $( this ).find( '.author .avatar' ).append( $avatar.clone() );
                } );

                this.$editorClone.find( '.author .avatar' ).append( $avatar.clone() );
            }

            if( $pagination.size() )
            {
                var $firstMessagePagination = $( '#thread-replies' );
                var $bottomPagination       = $( '#thread-bottom-navigation' );
                var isPrevEnabled = true;
                var isNextEnabled = true;
                var $ul = $pagination.eq( 0 ).clone().find( 'ul' );
                var $prev = $ul.find( '.lia-paging-page-previous' );
                var $next = $ul.find( '.lia-paging-page-next' );
                var $nav  = $( '<div />' );

                $prev.children().addClass( 'prev' );
                $next.children().addClass( 'next' );

                if( $prev.children().is( 'span' ) )
                {
                    isPrevEnabled = false;
                    this.replaceElementWith( $prev.children(), 'a' );
                }

                if( $next.children().is( 'span' ) )
                {
                    isNextEnabled = false;
                    this.replaceElementWith( $next.children(), 'a' );
                }

                $nav.append( $prev.html() );

                $ul.find( '.lia-paging-full-pages' ).children().each( function()
                {
                    var $this = $( this ).clone();
                    if( $this.children().is( 'span' ) )
                    {
                        that.replaceElementWith( $this.children(), 'a' );
                        $this.children().addClass( 'active' );
                    }

                    if ($this.children().text() == '…') {
                        $this.children().addClass('dots');
                    }

                    var href = $this.children().attr('href') + '#thread-replies';
                    $this.children().attr('href', href.replace( '##', '#' ));
                    $nav.append( $this.html() );
                } );

                $nav.append( $next.html() );
                $nav.find( '.lia-paging-page-link' ).remove();

                $firstMessagePagination.find( '.pagination' ).html( $nav.html() );
                $bottomPagination.find( '.pagination' ).html( $nav.html() );

                $firstMessagePagination.find( '.lia-link-disabled' ).click( function( e )
                {
                    e && e.preventDefault();
                } );

                $bottomPagination.find( '.lia-link-disabled' ).click( function( e )
                {
                    e && e.preventDefault();
                } );

                $firstMessagePagination.find( '.lia-link-navigation' ).click( this.changePage );
                $bottomPagination.find( '.lia-link-navigation' ).click( this.changePage );

            }
            else
            {
                $( '#thread-bottom-navigation' ).hide();
            }

            var prevLink = $('#threadnavigator .lia-component-previous .lia-link-navigation');
            var nextLink = $('#threadnavigator .lia-component-next .lia-link-navigation');
            var prevHref = prevLink.attr('href');
            var prevTitle = prevLink.attr('title');
            var nextHref = nextLink.attr('href');
            var nextTitle = nextLink.attr('title');
            var $prevNext = $( '#pdc6_prev_next_thread' );
            var $prev     = $prevNext.find( '.previous' );
            var $next     = $prevNext.find( '.next' );

            //set links
            if(prevHref !== undefined) {
                $prev.attr( 'href', prevHref );
                $prev.find( '.text .title').html( prevTitle );
            } else {
                $prev.hide();
            }

            if(nextHref !== undefined) {
                $next.attr('href',nextHref);
                $next.find( '.text .title').html(nextTitle);
            } else {
                $next.hide();
            }

            $prev.removeClass( 'loading' );
            $next.removeClass( 'loading' );
        },

        changePage : function( e )
        {
            /*
            e && e.preventDefault();

            var $temp = $( '<div />' );

            $temp.load( window.location.origin + $( this ).attr( 'href' ) + ' .threaded-detail-message-list.message-list', function( response )
            {
                $( '.lia-discussion-view-style-menus' ).nextAll().remove();
                $( '.threaded-detail-message-list.message-list' ).append( $temp.find( '.lia-discussion-view-style-menus' ).nextAll().html() );
            } );
            */
        },

        progressBar : function()
        {
            $( '.message-author-detail' ).find( '.author-radial-rank' ).each( function()
            {
                var progress = new ProgressBar.Circle( this, {
                    duration    : 0,
                    strokeWidth : 10,
                    color       : "#00a2ff",
                    trailColor  : "#5e5e5e"
                } );

                var p = $( this ).data( 'progress' );

                progress.set( p / 100 );
                //progress.setText( p );

                $( this ).data( 'progress-bar', progress );
            } );
        },

        scrollToMessage : function( $destination )
        {
            // unsetting the cookie
            $.removeCookie( 'new_message', { path : '/', domain : window.location.hostname });
            $.removeCookie( 'new_reply', { path : '/', domain : window.location.hostname });
            $.removeCookie( 'message_edited', { path : '/', domain : window.location.hostname });

            if( !$destination.size() )
            {
                return;
            }

            var that   = this
              , offset = $destination.offset().top;

            if( !this.t )
            {
                this.t = $( 'html, body' );
            }

            var d = 100;

            if( $( '.lia-panel-message-root' ).size() )
            {
                d = 270;
                var m = $destination.find( '.MessagesPositionInThread a' ).text();
                d = d + ( 35 * parseInt( m ) / 10 );
            }

            if( offset > 450 )
            {
                this.t.scrollTo( offset - d, 1000 );
            }
        }

    };

    $.fn.Thread = function( options )
    {
        var args     = Array.prototype.slice.call( arguments, 1 )
          , $item    = $( this )
          , instance = $item.data( 'Thread' );

        if( !instance )
        {
            instance = new Thread( this, options );
            $item.data( 'Thread', instance );
        }

        if( typeof options === 'string' )
        {
            instance[ options ].apply( instance, args );
        }

        return this;
    };

} )( jQuery, window, document );
